import { registerIconAlias } from '@uifabric/styling';
export var registerIconAliases = function () {
    registerIconAlias('trash', 'delete');
    registerIconAlias('onedrive', 'onedrivelogo');
};
//# sourceMappingURL=iconAliases.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/icons/lib/iconAliases.js
// module id = 283
// module chunks = 0